import {SET_PRODUCT} from './types';

export const setProduct = payload => ({
  type: SET_PRODUCT,
  payload,
});
